import { Schema } from "effect";

// A frame that is not a protocol message: a peer of another version, or not one of ours at all.
export class BadMessage extends Schema.TaggedError<BadMessage>("@beatdig/shared/errors/BadMessage")(
  "BadMessage",
  { text: Schema.String },
) {
  override get message(): string {
    return `bad message: ${this.text}`;
  }
}

// A write the socket refused: the other end is gone, or the socket never opened.
export class SendFailed extends Schema.TaggedError<SendFailed>("@beatdig/shared/errors/SendFailed")(
  "SendFailed",
  { message: Schema.String, cause: Schema.Defect() },
) {}

// The page's chart.json could not be fetched or is not a chart; `reason` says where it went wrong,
// for whoever is editing it.
export class BadChart extends Schema.TaggedError<BadChart>("@beatdig/shared/errors/BadChart")(
  "BadChart",
  { reason: Schema.String, cause: Schema.Defect() },
) {
  override get message(): string {
    return `chart.json: ${this.reason}`;
  }
}

// The client's socket closed, with the close code and reason the other end gave.
export class Disconnected extends Schema.TaggedError<Disconnected>(
  "@beatdig/shared/errors/Disconnected",
)("Disconnected", { code: Schema.Int, reason: Schema.String }) {
  override get message(): string {
    return this.reason === ""
      ? `disconnected: ${String(this.code)}`
      : `disconnected: ${String(this.code)} ${this.reason}`;
  }
}
